import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllTiktokAdReportSummary.graphql';
import { Query, QueryallTiktokAdReportSummaryArgs } from '../../__generated__/globalTypes';

export const useAllTiktokAdReportSummaryQuery = (
  options?: QueryHookOptions<Query, QueryallTiktokAdReportSummaryArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallTiktokAdReportSummaryArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllTiktokAdReportSummaryLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallTiktokAdReportSummaryArgs>
): QueryResult<Query, QueryallTiktokAdReportSummaryArgs> & {
  getAllTiktokAdReportSummary: LazyQueryExecFunction<Query, QueryallTiktokAdReportSummaryArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllTiktokAdReportSummary, result] = useLazyQuery<Query, QueryallTiktokAdReportSummaryArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllTiktokAdReportSummary, ...result };
};

export const useAllTiktokAdReportSummaryPromiseQuery = () => {
  const client = useApolloClient();

  const getAllTiktokAdReportSummary = useCallback(
    (options?: Omit<QueryOptions<QueryallTiktokAdReportSummaryArgs, Query>, 'query'>) =>
      client.query<Query, QueryallTiktokAdReportSummaryArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllTiktokAdReportSummary };
};
// Suspense Query Hooks
export const useAllTiktokAdReportSummarySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallTiktokAdReportSummaryArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallTiktokAdReportSummaryArgs>(QUERY, {
    ...options
  });

  return result;
};
